// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16e1B","type":"styles_type__2tiKH","choices":"styles_choices__1Hkk9"};